import { render, staticRenderFns } from "./creatGrade.vue?vue&type=template&id=ff8c45c0&scoped=true"
import script from "./creatGrade.vue?vue&type=script&lang=js"
export * from "./creatGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c45c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff8c45c0')) {
      api.createRecord('ff8c45c0', component.options)
    } else {
      api.reload('ff8c45c0', component.options)
    }
    module.hot.accept("./creatGrade.vue?vue&type=template&id=ff8c45c0&scoped=true", function () {
      api.rerender('ff8c45c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/grade/creatGrade.vue"
export default component.exports